module.exports = __webpack_public_path__ + "static/media/nextIcon.b3e30db2.svg";